import { render, staticRenderFns } from "./BundleObservasiList.vue?vue&type=template&id=8728b946&scoped=true&"
import script from "./BundleObservasiList.vue?vue&type=script&lang=ts&"
export * from "./BundleObservasiList.vue?vue&type=script&lang=ts&"
import style0 from "./BundleObservasiList.vue?vue&type=style&index=0&id=8728b946&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8728b946",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VChip,VIcon,VSimpleTable,VSpacer})
